export default {"src":"/_next/static/media/ballet.19ae269b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};